import { NavigationNode } from '@/src/lib/navigation/type';

export function removeTrailingSlash(path?: string | null) {
  return path?.replace(/\/$/, '');
}

export function isActiveNavigationNode(node: NavigationNode, path: string | null): boolean {
  const hasMatch = removeTrailingSlash(node.url) === path || removeTrailingSlash(node.url) === path;

  if (hasMatch) return true;

  const childrenMatches = node.children?.map((child) => isActiveNavigationNode(child, path)) || [];
  const flattedChildrenMatches = childrenMatches.flat();

  return flattedChildrenMatches.some((match) => match);
}

export function areEqualNavigationNodes(nodeA: NavigationNode | undefined, nodeB: NavigationNode | undefined) {
  return JSON.stringify(nodeA) === JSON.stringify(nodeB);
}
